<template>
  <div>
    <h2>Classification</h2>
    <div class="col-100 recherche-avancee-produits-classification">
      <div
        v-for="(category, key, index) in classificationsList"
        :key="key"
        class="table-block"
      >
        <div class="row table_head">
          <div class="cell">{{ key }}</div>
          <div class="cell">Libellé</div>
        </div>
        <div
          v-for="(
            multivaluedClassification, indexMultivalued
          ) in classifications[index]"
          :key="indexMultivalued"
          class="row relative"
        >
          <div class="cell">
            <label
              class=""
              :style="{
                visibility: indexMultivalued === 0 ? 'hidden' : 'visible',
              }"
              >et
              <!-- <option value="">et</option>
               <option value="true">et</option>
              <option value="false">ou</option> -->
            </label>
            <select
              :value="classifications[index][indexMultivalued]['clauseType']"
              @input="
                $emit(
                  'update:classifications',
                  getUpdatedClassifications(
                    index,
                    indexMultivalued,
                    'clauseType',
                    $event.target.value
                  )
                )
              "
              :required="
                Boolean(classifications[index][indexMultivalued]['value'])
              "
            >
              <option value=""></option>
              <option value="true">contient</option>
              <option value="false">ne contient pas</option>
            </select>
            
          </div>

          <div class="cell">
            <select
              :value="classifications[index][indexMultivalued]['value']"
              @input="
                $emit(
                  'update:classifications',
                  getUpdatedClassifications(
                    index,
                    indexMultivalued,
                    'value',
                    $event.target.value
                  )
                )
              "
              :required="
                Boolean(classifications[index][indexMultivalued]['clauseType'])
              "
            >
              <option value=""></option>
              <option
                v-for="classification in category"
                :key="classification.class_code"
                :value="classification.class_code"
              >
                {{
                  classification.class_code +
                  " - " +
                  classification.class_category
                }}
              </option>
            </select>

            <div
              v-if="indexMultivalued === classifications[index].length - 1"
              class="ajout-element"
              @click="$emit('update:classifications', addRow(index))"
            ></div>
            <div
              v-else
              class="suppr-element"
              @click="
                $emit('update:classifications', delRow(index, indexMultivalued))
              "
            ></div>
          </div>
        </div>
        <div
              v-if="
                key ===
                'Mentions de danger (phrases H) et informations additionnelles (phrases EUH)'
              "
              class="checkbox my-2"
            >
              <label>
                <input
                  :value="cmr"
                  :checked="cmr === true"
                  v-model="cmr"
                  @change="
                    $emit(
                      'update:cmr',
                      $event.target.checked ? true : false
                    )
                  "
                  type="checkbox"
                  id="identite-mention-abeille"
                />
                CMR (catégorie 1 ou 2), effet sur / via allaitement
              </label>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClassificationForm',

  props: {
    classifications: Array,
    classificationsList: Object,
    cmr: {required: false},

    
  },

  methods: {
    getUpdatedClassifications (index, indexMultivalued, property, newValue) {
      let classifications = [...this.classifications]
      Object.defineProperty(
        classifications[index][indexMultivalued],
        property,
        {
          value: newValue,
          writable: true
        }
      )
      return classifications
    },

    addRow (rowIndex) {
      let classifications = [...this.classifications]
      classifications[rowIndex] = classifications[rowIndex].concat({
        clauseType: '',
        value: ''
      })
      return classifications
    },

    delRow (rowIndex, index) {
      let classifications = [...this.classifications]
      classifications[rowIndex] = classifications[rowIndex].filter(
        (value, i) => i !== index
      )
      return classifications
    }
  }
}
</script>
